import {
  SET_LOADING_STATUS,
  SET_MITRA_ITEMS,
  SET_MITRA_ITEM_TRANSACTION,
} from './mutationTypes';
import STATUS_MAP from '../../../constants/statusMap';

function buildMitraItemWithTransaction(item, transaction = undefined) {
  const transactionStatus = transaction?.status;
  const itemStatus = item.status;
  let finalStatus = transactionStatus || itemStatus;

  // ignore rejected, failed, expired status
  if (['rejected', 'failed', 'expired'].includes(finalStatus)) {
    finalStatus = itemStatus;
  }
  return {
    ...item,
    transaction,
    status: finalStatus,
    humanized_status: STATUS_MAP[finalStatus] || STATUS_MAP.unknown,
  };
}

export default {
  [SET_LOADING_STATUS]: (state, status) => {
    state.loadingStatus = status;
  },
  [SET_MITRA_ITEMS]: (state, list) => {
    state.mitraItems = list;
  },
  [SET_MITRA_ITEM_TRANSACTION]: (state, { mitraItemId, transaction }) => {
    const index = state.mitraItems.findIndex(item => item.id === mitraItemId);
    state.mitraItems[index] = buildMitraItemWithTransaction(
      state.mitraItems[index],
      transaction,
    );
  },
};
